<script>
import { mapGetters } from 'vuex';
import CustomerFraudRatingFilter from '@/V2/components/filters/CustomerFraudRatingFilter';
import OwnerFilter from '@/V2/components/filters/OwnerFilter';
import CustomerTagsFilter from '@/V2/components/filters/CustomerTagsFilter';
import CustomerDateFilter from '@/V2/components/filters/CustomerDateFilter';
import CustomerStatusesFilter from '@/V2/components/filters/CustomerStatusesFilter';

export default {
  components: {
    CustomerDateFilter,
    CustomerFraudRatingFilter,
    OwnerFilter,
    CustomerTagsFilter,
    CustomerStatusesFilter,
  },
  props: {
    justifyContent: {
      type: String,
      default: 'start',
      validator: (prop) => ['start', 'center', 'end'].includes(prop),
    },
    dataLoading: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    ...mapGetters(['isOrgAdvancedUserOrAdmin']),
  },
  methods: {
    trackFilter(eventName) {
      window.analytics.track(eventName);
    },
  },
};
</script>

<template>
  <div
    :class="[
      'customer-filters__wrapper d-flex flex-row align-items-center',
      `justify-content-${justifyContent}`,
    ]"
  >
    <CustomerDateFilter ref="customerDateFilter" :loading="dataLoading" />
    <OwnerFilter v-if="isOrgAdvancedUserOrAdmin" />
    <CustomerStatusesFilter entity="customers" />
    <CustomerFraudRatingFilter />
    <CustomerTagsFilter />
    <slot />
  </div>
</template>

<style lang="scss" scoped>
.customer-filters {
  &__wrapper {
    gap: map-get($increments, 3);
  }
}
</style>
